import config from '../app-config';
import logoMuncipality from '../images/logo-gemeente.png';
import logoProvince from '../images/logo-provincie.png';

const Navbar = () => {
    return (
        <nav className="navbar navbar-expand-lg fixed-top navbar-north bg-white" role="navigation" id="navbarNorth">
            <div className="container justify-content-start" id="navbarNorthContainer">

                <a href="./index.html" className="logotype logotype-black logotype logotype-black col-sm-3 col-md-2 mr-lg-n5" role="banner">Sweco</a>
                <img className="col-4 col-sm-3 col-lg-2 mt-n1" width="130px" src={logoProvince} alt="afbeelding provincie"></img>
                <img className="col-4 ml-n3 ml-0 pl-lg-7 col-sm-3 col-lg-2" width="130px" src={logoMuncipality} alt="afbeelding gemeente"></img>

                {/* <div className="col-2"> */}
                    <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarNorthNav" aria-controls="navbarNorthNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="btn-nav-box">
                            <span className="btn-nav-inner"></span>
                        </span>
                    </button>
                {/* </div> */}

                <div className="col-6">
                    <div className="collapse navbar-collapse justify-content-end" id="navbarNorthNav">

                        <div className="navbar-nav mr-md-19 ">
                            <ul className="nav">
                                {config.navBarItems.map(item => (
                                    <li key={item.id} className="nav-item">
                                        <a type="button" className="btn nav-link text-dark" href={`#${item.id}`}>{item.text}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            <div id="progress-container" className="progress-navbar"></div>
        </nav>
    );
}

export default Navbar;